import { fileSizeToHumanReadable } from '@mssgme/shared';

// TODO: remove formatter, do simpler
export default (value, format, locale) => {
    if (format === 'filesize') {
        return fileSizeToHumanReadable(+value);
    }
};
